import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, OnInit, Input } from '@angular/core';
import { EventsService } from '../../../../shared/services';

@Component({
  selector: 'app-whatsapp-msg',
  templateUrl: './whatsapp-msg.component.html',
  styleUrls: ['./whatsapp-msg.component.scss']
})
export class WhatsappMsgComponent implements OnInit {
  @Input() public html;
  @Input() public label;
  @Input() public btnClass;
  @Input() public info2;
  @Input() public origin = 'body';
  constructor(
    public eventService: EventsService,
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
  }

  systemEvent(event) {
    const payload = {
      eventName: 'wa_chat_with_us',
      event_type: 'campaign',
      info_1: 'type',
      info_2: this.info2
    };
    this.eventService.sendSystemEvent(payload).subscribe(() => {
    });
    this.eventService.userGTMEvents({
      event: 'chat_click',
      event_category: 'navigation',
      event_action: 'whatsapp chat click',
      event_label: `${event.target.innerText}|${this.origin}`
    });
  }
}
